export default theme => ({
  root: {
    width: '100%',
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: '10px 16px',
    '& > *': {
      display: 'inline-block',
      width: 18,
      height: 18
    },
    '& path': {
      fill: theme.colors.grey[100]
    },
    '& [class*="Icon"]:hover path': {
      fill: theme.colors.grey[700]
    }
  }
});